import React, { useContext, useEffect, useState } from "react";
import { PageComponent } from "../../components/PageComponent";
import { getDonorDataServiceInstance } from "../../../services/bexWISE/donorDataService/getDonorDataServiceInstance";
import { AuthContext } from "../../contexts/auth/authContext";
import { IDonorContactPreference } from "../../../services/bexWISE/donorDataService/IDonorDataService";
import { useMediaQuery } from "react-responsive";
import { Section } from "../../components/Section/Section";
import { Col, Row } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import PreferencesImg from "../../../assets/images/preferences.png";
import { switchesSectionsContent } from "./consts";
import SwitchSectionComponent from "./components/SwitchSectionComponent";
import { PreferencesContainer } from "./styled";
// == SCREDP-95 Allow Admin Customization of Text Displayed on Various Donor Portal Pages ==
import { EnvironmentContext } from "app/contexts/environment/environmentContext";
import { isStringNullUndefinedOrEmpty } from "../MyDonationPage/utils/utils";

const PreferencesPage = () => {
   // == SCREDP-95 Allow Admin Customization of Text Displayed on Various Donor Portal Pages ==
   const { environmentConfig } = React.useContext(EnvironmentContext);
   const [preferencesData, setPreferencesData] = useState<
      IDonorContactPreference[]
   >([]);
   const { userDonorId } = useContext(AuthContext);
   const [preferencesDisplayData, setPreferencesDisplayData] =
      useState<IDonorContactPreference[]>(preferencesData);
   const isMobile: boolean = useMediaQuery({ maxWidth: 767 });
   const padding: string = React.useMemo(
      () => (isMobile ? "" : "p-5"),
      [isMobile],
   );
   useEffect(() => {
      if (userDonorId) {
         getDonorDataServiceInstance()
            .getDonorContactPreferences(userDonorId)
            .then((response: IDonorContactPreference[]) => {
               setPreferencesData(response);
               //SCREDP-62 QAClone - Donor Portal - Preference Page not updating
               setPreferencesDisplayData(response)
            });
      }
   }, []);
   // == SCREDP-95 Allow Admin Customization of Text Displayed on Various Donor Portal Pages ==
   switchesSectionsContent.map(eachSwitchSection => {

      switch (eachSwitchSection.id) {
         case "home":
            if(!isStringNullUndefinedOrEmpty(environmentConfig?.homePreferenceMessage)){
               eachSwitchSection.message = environmentConfig?.homePreferenceMessage;
            }
            break;
         case "cellPh":
            if(!isStringNullUndefinedOrEmpty(environmentConfig?.cellPhonePreferenceMessage)){
               eachSwitchSection.message = environmentConfig?.cellPhonePreferenceMessage;
            }
            break;
         case "business":
            if(!isStringNullUndefinedOrEmpty(environmentConfig?.businessPreferenceMessage)){
               eachSwitchSection.message = environmentConfig?.businessPreferenceMessage;
            }
            break;
         case "unsubscribe":
            if(!isStringNullUndefinedOrEmpty(environmentConfig?.unsubscribePreferenceMessage)){
               eachSwitchSection.message = environmentConfig?.unsubscribePreferenceMessage;
            }
            break;
      }
   }

   );
   
   return (
      <PageComponent
         name={"Preferences Page"}
         title={"Preferences Page"}
         description={"Preferences Page"}
      >
         <PreferencesContainer
            className={isMobile ? "mobile-container-css mt-3" : "mt-3"}
         >
            <Section
               header={{
                  title: "Preferences",
               }}
            >
               <Row
                  className={`preferences-content-section ${padding} ${isMobile ? "mobile-css" : "desktop-css"
                     }`}
               >
                  {!isMobile && (
                     <Col md={4} className="preferences-left-section">
                        <Image
                           src={PreferencesImg}
                           fluid
                           alt="preferences-img"
                           className="preferences-img-css"
                        />
                        <div className="preferences-img-content">
                           {/* SCREDP-95 Allow Admin Customization of Text Displayed on Various Donor Portal Pages */}
                           {isStringNullUndefinedOrEmpty(environmentConfig?.contactPreferencesMessage)
                            &&(
                              <>
                                 If there are changes needed to any of <br />
                                 these contact preferences, please reach
                                 <br /> out to your blood center.
                              </>
                           )}
                           {  !isStringNullUndefinedOrEmpty(environmentConfig?.contactPreferencesMessage) &&(
                              <>
                                 {environmentConfig?.contactPreferencesMessage}
                              </>
                           )}
                        </div>
                     </Col>
                  )}
                  <Col md={8} sm={12} xs={12} className="preferences-right-section">
                     <div className="switch-header-content">
                        <b>I prefer to be contacted by:</b>
                     </div>
                     {switchesSectionsContent.map(eachSwitchSection => (
                        <div key={eachSwitchSection.id}>
                           {eachSwitchSection.id === "unsubscribe" && (
                              <hr className="unsubscribe-hr-css" />
                           )}
                           <SwitchSectionComponent
                              sectionsContent={eachSwitchSection}
                              preferencesDisplayData={preferencesDisplayData}
                              setPreferencesDisplayData={setPreferencesDisplayData}
                              isMobile={isMobile}
                           />
                        </div>
                     ))}
                     {isMobile && (
                        <div className="preferences-img-mobile-content">
                           {/* SCREDP-95 Allow Admin Customization of Text Displayed on Various Donor Portal Pages */}
                           {isStringNullUndefinedOrEmpty(environmentConfig?.contactPreferencesMessage) &&(
                              <>
                                 If there are changes needed to any of <br />
                                 these contact preferences, please reach
                                 <br /> out to your blood center.
                              </>
                           )}
                           {!isStringNullUndefinedOrEmpty(environmentConfig?.contactPreferencesMessage) &&(
                              <>
                                 {environmentConfig?.contactPreferencesMessage}
                              </>
                           )}
                        </div>
                     )}
                  </Col>
               </Row>
            </Section>
         </PreferencesContainer>
      </PageComponent>
   );
};

export default PreferencesPage;
